import React, { Component } from 'react';
import ScoreboxRound from 'components/scorebox-round';

export default class ScoreboxModal extends Component {
  render() {
    const { active, closeModal, match, type } = this.props;

    let classes = ['scorebox-modal', 'modal', type];

    if (active) {
      classes.push('is-active');
    }

    let content = null;

    if (match) {
      content = match.rounds.map((round) => (
        <div key={round.fnMatchRoundID} className="scorebox-modal--round">
          <ScoreboxRound
            round={round}
            match={match}
            type={type}
            team1={match.draft_match.teams.team1}
            team2={match.draft_match.teams.team2}
          />
        </div>
      ));
    }

    return (
      <div className={classes.join(' ')}>
        <div className="modal-background" onClick={closeModal} />
        <div className="modal-card animated fadeIn">
          <header className="modal-card-head">
            <p className="modal-card-title">Scorebox</p>
            <button
              className="delete"
              aria-label="close"
              onClick={closeModal}
            />
          </header>
          <section className="modal-card-body">{content}</section>
          <footer className="modal-card-foot" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/scorebox-modal/scorebox-modal.js